import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../api/client";

interface LogoutResponse {
  ok: boolean;
  code: string;
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation<LogoutResponse, ApiError, void>({
    mutationFn: () => apiPost<LogoutResponse>("/api/auth/pm/logout"),
    onSuccess: () => {
      // Audit W4-016 — `qc.clear()` is intentional and heavy: it drops every
      // cache entry across the app (PM session probe, asset list, history
      // queries, settings, exports, etc.). The next mounted screen will
      // re-fetch from scratch with fresh credentials. Targeted invalidation
      // would leave us guessing which queries depended on the previous
      // session, and a stale cache after PIN/password change is a
      // light-security correctness risk we deliberately don't take.
      qc.clear();
      // No navigate here — caller (HomeShell sign-out button) wires navigate() after success.
    },
  });
}
